import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { format, parseJSON } from 'date-fns';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import Icon from 'src/components/Icon/Icon';
import Button from 'src/components/Button/Button';
import RangePicker, { DateRangeProps } from 'src/components/RangePicker/RangePicker';
import './TillFilters.scss';
import ClickAwayListener from '@material-ui/core/ClickAwayListener/ClickAwayListener';

interface TillFiltersProps{
  dateRange: DateRangeProps[]
  setDateRange: Function,
  loginTime: number,
  setFilterType: Function,
  filterType: string,
  changeOptions: Function,
  selectedOptions: { limit: number, order: string }
}

function TillFilters({ setDateRange, loginTime, setFilterType, filterType, changeOptions, selectedOptions }: TillFiltersProps) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [openLimit, setOpenLimit] = useState(false);
  const [openOrder, setOpenOrder]= useState(false);
  const [dateRanges, setDateRanges] = useState([{
    startDate: parseJSON(loginTime * 1000),
    endDate: new Date(),
    key: 'selection'
  }]);

  const [openMenu, setOpenMenu] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedButton, setSelectedButton]= useState(0);

  const options = { limit: [10, 20, 50, 100], order: ['Asc', 'Desc'] };

  useEffect(() => {
    const loadTypes = async () => {
      const types = await dispatch.peripherals.getTransactionTypesHistory();
      setTransactionTypeList(types);
    };

    loadTypes();
  }, []);

  const handleFilterApply = async () => {
    setDateRange(dateRanges);
    setSelectedButton(1);
    setShowFilter(false);
  };

  const onDateChange = (range:DateRangeProps[]) => {
    setDateRanges(range);
  };

  const handleRangeClear = async () => {
    setDateRanges([{
      startDate: parseJSON(loginTime * 1000),
      endDate: new Date(),
      key: 'selection'
    }]);
    setDateRange([{
      startDate: parseJSON(loginTime * 1000),
      endDate: new Date(),
      key: 'selection'
    }]);
    setShowFilter(false);
  };

  const handleTypeChange = (e) => {
    setOpenMenu(false);
    setFilterType(e.target.value);
    setSelectedButton(2);
  };

  // eslint-disable-next-line no-unused-vars
  const checkDate = () => {
    const startDate = format(dateRanges[0]?.startDate, 'dd MMM');
    const endDate = format(dateRanges[0]?.endDate, 'dd MMM');
    if (startDate === endDate){
      return startDate.toString();
    }
    return `${ startDate } - ${ endDate }`;
  };

  return (
    <>
      <div className="till-filters">
        { /* Temporary hidden Button  */ }
        { /* <Button
          size="big"
          type="submit"
          className={
            classNames({
              'btn--primary till-filters__button till-filters__button--date': true,
              'till-filters__button--selected': selectedButton === 1
            })
          }
          onClick={ () => setShowFilter(!showFilter) }
        >
          <Icon
            icon="filter"
            className="till-filters__calendar"
          />
          { !_.isEmpty(dateRanges[0]) ? checkDate() : t('transactions.all') }
        </Button> */ }
        <div className="till-filters__options-container">
          <div className="till-filters__transaction-type">

            <Button
              size="big"
              type="submit"
              className={
                classNames({
                  'btn--primary till-filters__button till-filters__button--type': true,
                  'till-filters__button--selected': selectedButton === 2
                })
              }
              onClick={ () => setOpenMenu(true) }
            >
              <Icon
                icon="filter"
                className="till-filters__calendar"
              />
              {
                !_.isEmpty(transactionTypeList)
        && filterType !== ''
        && _.find(transactionTypeList, { id: +filterType })
        && +filterType !== -1 ? _.find(transactionTypeList, { id: +filterType }).name : t('transactions.all')
              }
            </Button>
          </div>
          {
            showFilter && (
              <div className="till-filters__filter-container">
                <RangePicker
                  iconClick = { () => setShowFilter(!showFilter) }
                  handleApply = { handleFilterApply }
                  clear = { handleRangeClear }
                  dateChange = { onDateChange }
                  ranges = { dateRanges }
                />
              </div>
            )
          }
          {
            openMenu && (
              <ClickAwayListener onClickAway={ () => setOpenMenu(false) }>
                <ul className="till-filters__type">
                  <li
                    className={
                      classNames({
                        'till-filters__item': true,
                        'till-filters__item--selected': +filterType === -1
                      })
                    }
                    onClick={ handleTypeChange }
                    value={ -1 }
                  >{ t('transactions.all') }</li>
                  {
                    _.map(transactionTypeList, (transaction) => {
                      return (
                        <li
                          className={
                            classNames({
                              'till-filters__item': true,
                              'till-filters__item--selected': +filterType === transaction.id
                            })
                          }
                          onClick={ handleTypeChange }
                          key={ transaction.id }
                          value={ transaction.id }
                        >
                          { transaction.name }
                        </li>
                      );
                    })
                  }
                </ul>
              </ClickAwayListener>
            )
          }
          <div className="till-filters__transaction-type">
            <div className="till-filters__search" onClick={ () => setOpenLimit(!openLimit) }>
              <h3>
                { selectedOptions.limit }
              </h3>
              <Icon
                className={
                  classNames({
                    'till-filters__icon': true,
                    'till-filters__icon--closed': !openLimit
                  })
                }
                icon="dropdownArrow"
              />
              {
                openLimit &&
              <ClickAwayListener onClickAway={ () => setOpenLimit(false) }>
                <ul className="till-filters__type">
                  {
                    _.map(options.limit, (limit) => {
                      return (
                        <li
                          className={
                            classNames({
                              'till-filters__item': true,
                              'till-filters__item--selected': selectedOptions.limit === limit
                            })
                          }
                          onClick={ () => changeOptions('limit', limit) }
                          key={ limit }
                          value={ limit }
                        >
                          { limit }
                        </li>
                      );
                    })
                  }
                </ul>
              </ClickAwayListener>
              }
            </div>
          </div>
          <div className="till-filters__transaction-type">
            <div className="till-filters__search" onClick={ () => setOpenOrder(!openLimit) }>
              <h3>
                { selectedOptions.order }
              </h3>
              <Icon
                className={
                  classNames({
                    'till-filters__icon': true,
                    'till-filters__icon--closed': !openOrder
                  })
                }
                icon="dropdownArrow"
              />
              {
                openOrder &&
                <ClickAwayListener onClickAway={ () => setOpenOrder(false) }>
                  <ul className="till-filters__type">
                    {
                      _.map(options.order, (order) => {
                        return (
                          <li
                            className={
                              classNames({
                                'till-filters__item': true,
                                'till-filters__item--selected': selectedOptions.order === order
                              })
                            }
                            onClick={ () => changeOptions('order', order) }
                            key={ order }
                            value={ order }
                          >
                            { order }
                          </li>
                        );
                      })
                    }
                  </ul>
                </ClickAwayListener>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TillFilters;
